import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import moment from "moment";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";

const DEFAULT_RANGE_FORMAT = "ddd, MMM D, YYYY";
// Text for the default range (1st of this month - today)
const defaultRangeText = () =>
  `${moment().startOf("month").format(DEFAULT_RANGE_FORMAT)} - ${moment().startOf("day").format(DEFAULT_RANGE_FORMAT)}`;

const DatePickerComponent = ({
  onDateRangeChange,
  isFlatPikerReset = false,
  showDefaultRange = false // show this month's range in the input when no range is applied yet
}) => {
  const inputRef = useRef(null);
  const pickerRef = useRef(null);
  const [isActive, setIsActive] = useState(showDefaultRange);
  const [hasValue, setHasValue] = useState(false);
  useEffect(() => {
    const $input = $(inputRef.current);

    $input.daterangepicker({
      timePicker: false,
      startDate: moment().startOf("month"),
      endDate: moment().startOf("day"),
      locale: {
        format: "ddd, MMM D, YYYY",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        monthNames: [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ],
        firstDay: 0
      },
      opens: "center",
      drops: "down",
      showDropdowns: true,
      linkedCalendars: false,
      autoUpdateInput: false,
      alwaysShowCalendars: true,
      autoApply: false,
    });

    pickerRef.current = $input.data("daterangepicker");

    if (showDefaultRange && !$input.val()) {
      $input.val(defaultRangeText());
    }

    // APPLY
    $input.on("apply.daterangepicker", function (ev, picker) {
      const startFormatted = picker.startDate.format("ddd, MMM D, YYYY");
      const endFormatted = picker.endDate.format("ddd, MMM D, YYYY");
      const displayValue = `${startFormatted} - ${endFormatted}`;

      $input.val(displayValue);

      const dates = [picker.startDate.toDate(), picker.endDate.toDate()];

      if (onDateRangeChange) {
        onDateRangeChange(dates);
      }

      setHasValue(true);
      setIsActive(true);
    });

    // CANCEL
    $input.on("cancel.daterangepicker", function () {
      // With a default range the applied filter is still active, so keep its text
      if (showDefaultRange) return;
      $input.val("");
      setHasValue(false);
      setIsActive(false);
    });

    // SHOW
    $input.on("show.daterangepicker", function () {
      setIsActive(true);
    });

    // HIDE
    $input.on("hide.daterangepicker", function () {
      if (!hasValue && !showDefaultRange) {
        setIsActive(false);
      }
    });

    return () => {
      $input.off(".daterangepicker");
      if ($input.data("daterangepicker")) {
        $input.data("daterangepicker").remove();
      }
    };
  }, [onDateRangeChange, hasValue, showDefaultRange]);

  // Reset logic
  useEffect(() => {
    if (isFlatPikerReset && pickerRef.current) {
      $(inputRef.current).val(showDefaultRange ? defaultRangeText() : "");
      pickerRef.current.setStartDate(moment().startOf("month"));
      pickerRef.current.setEndDate(moment().startOf("day"));
      setHasValue(false);
      setIsActive(showDefaultRange);
    }
  }, [isFlatPikerReset, showDefaultRange]);

  const openDatePicker = () => {
    if (pickerRef.current) {
      pickerRef.current.show();
    }
  };

  return (
    <div className={`datepker position-relative ${isActive ? "active" : ""}`}>
      <span
        className="position-absolute end-0 top-50 translate-middle-y me-12 line-height-1"
        onClick={openDatePicker}
        style={{ cursor: "pointer" }}
      >
        <iconify-icon
          icon="solar:calendar-linear"
          className="icon text-lg"
        ></iconify-icon>
      </span>

      <input
        type="text"
        ref={inputRef}
        className="form-control radius-8 bg-base"
        placeholder="Date"
        readOnly
        style={{ fontSize: "13px" }}
      />
    </div>
  );
};

export default DatePickerComponent;
